import { useEffect, useCallback } from 'react';
import {
  useItinerarySelector,
  useOffer,
  useSearchCriteriaSelector,
} from '@/providers/PriceFreezeOfferProvider';
import { useLogin } from '@/providers/login/LoginProvider';
import {
  funnelContextDatalayerUpdater,
  funnelContextCustomDimensionUpdater,
} from '@/tracking/funnelContextUpdater';
import { SB_ID, usePriceFreezeSession } from '@/hooks/usePriceFreezeSession';
import { useLogger, useDatalayerTracking } from '@edreamsodigeo/frontend-core';

export function AnalyticsDataListener() {
  const { save: saveDatalayer } = useDatalayerTracking();
  const itinerary = useItinerarySelector((itinerary) => itinerary);
  const offer = useOffer();
  const searchCriteria = useSearchCriteriaSelector((sc) => sc);
  const { isPrime } = useLogin();
  const [getSessionItem] = usePriceFreezeSession();
  const sbId = getSessionItem(SB_ID);

  const customDimensionsUpdater = useCallback(() => {
    funnelContextCustomDimensionUpdater.update({
      itinerary,
      offer,
      searchCriteria,
      sbId,
    });
  }, [itinerary, offer, searchCriteria, sbId]);

  const datalayerUpdater = useCallback(() => {
    funnelContextDatalayerUpdater.update({ itinerary, isPrime }, saveDatalayer);
  }, [itinerary, isPrime, saveDatalayer]);

  useTrackingUpdater(customDimensionsUpdater);
  useTrackingUpdater(datalayerUpdater);

  return null;
}

function useTrackingUpdater(updater) {
  const logger = useLogger();

  useEffect(() => {
    try {
      updater();
    } catch (err) {
      logger.warn(
        `frontend-price-freeze: error adding tracking context - ${err.message}`
      );
    }
  }, [updater, logger]);
}
